export const MODULE_NAME = 'BLOG_MODULE';

export const BLOG_IMAGE_ASPECT_RATIO = { width: 16, height: 9 };

export const BLOGS_PAGE_SIZE = 20;
